import React from "react";
import LayoutMensajesVirgen from "../components/LayoutMensajesVirgen";

export default function MensajesVirgenFr() {
  return (
    <>
      <LayoutMensajesVirgen>
        <div className="col-12 text-center">
          <h5> JE SUIS LA MÈRE IMMACULEE DU DIVIN</h5>
          <h5> CŒUR EUCHARISTIQUE DE JÉSUS </h5>
          <br />
          <p>
            {" "}
            Que soit Béni et adoré le Très Saint Sacré Cœur Eucharistique de
            Jésus»»{" "}
          </p>
          <h5>«MESSAGES DE LA TRÈS SAINTE VIERGE»</h5>
        </div>

        <div className="col-12 text-center mt-5">
          <h5> 1990 - 1997 </h5>
          <h5>Ma Mère très pure</h5>
          <h5>Je veux te consacrer mon cœur, ma volonté, ma vie entière</h5>
          <p>
            Emmène-moi au Cœur de ton Divin Fils Jésus Afin qu’Il habite en moi.{" "}
            <br />
            Je veux être à toi, totalement, ma Mère, À partir d’aujourd’hui, je
            veux te servir fidèlement dans tout ce que tu me diras. <br />
            Permets que je ne sois jamais séparé de toi <br />
            À l’heure de ma mort viens me chercher <br />
            Pour profiter de l’éternité en ta compagnie. <br />
            Sois bénie et louée pour toujours ma Mère. <br />
            Amen.
          </p>
        </div>
        <div className="col-12 text-center">
          <strong>Salta - Argentine - 1990</strong>
        </div>

        <div className="col-12 mt-5">
          <p>
            «IL FAUT RASSEMBLER LE TROUPEAU AVANT QU’IL NE FASSE NUIT. JE NE
            SUIS PAS VENUE POUR CRITIQUER OU DÉTRUIRE MAIS POUR CONSTRUIRE»
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 juillet 1990</h6>
          <p>
            <strong>NOTRE DAME DES LARMES</strong>te dira le 16 ce qu’elle veut,
            tu dois beaucoup prier pour les pécheurs, pour les affligés, pour
            ceux qui souffrent. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>31 juillet 1990 (pendant que je priais)</h6>
          <p>
            <strong>L’ IMMACULEE CONCEPTION</strong>a dit: «Je ferai une grande
            manifestation pour que tous te croient».
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>
            <strong>11 août 1990</strong>
          </h6>
          <p>
            (Après m’être consacrée au Seigneur, Notre Dame a ouvert ses bras et
            a dit en souriant très joyeusement) <br />
            «Viens ma fille, Loué soit le Seigneur, les Anges t’accompagneront,
            le Seigneur ouvrira un chemin de lumière»
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Jeudi 16 août 1990</h6>
          <p>
            Maria: Tu dois prier pour la paix du monde qui est menacée, pour les
            pécheurs, pour ceux qui souffrent, pour les affligés. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Vendredi 17 août 1990</h6>
          <p>
            <strong>NOTRE DAME DES LARMES</strong>m’envoie vous dire: <br />
            «Je serai bientôt parmi vous, je dois aider ceux qui ont besoin de
            moi, beaucoup de mes enfants souffrent à cause de la situation
            angoissante, c’est à eux que je donnerai ma Miséricorde. J’ai aussi
            besoin d’un endroit pour mon Fils Béni aussi, avec son Église. J’y
            ferai de grandes choses. Vite, car il y a beaucoup de nécessiteux!»{" "}
            <br />
            Je vous bénirai Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>31 août 1990</h6>
          <p>
            Mes enfants, Le Chapelet ne doit pas être utilisé comme une
            amulette. Grâce à la prière quotidienne du Saint chapelet, nous
            invoquons la protection divine et nous révérons Dieu. <br />
            A notre chère jeunesse, je demande de tourner ses yeux vers Jésus,
            pour sauver le monde du péché dans lequel il est submergé. <br />
            La prière quotidienne et simple plaît à Notre Seigneur par dessus
            toute autre chose. <br />
            Priez tous avec grande dévotion et la paix sera donnée aux âmes qui
            se prépareront pour le Seigneur. <br />
            Je vous bénirai. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5 Septembre 1990</h6>
          <p>
            Ma fille, Tu dois dire chaque jour le Saint chapelet. En élevant
            cette prière vers Dieu, pour l’humanité souffrante, tu me rends très
            heureuse. <br />
            Ce sera la manière dont tu me feras connaître auprès des coeurs qui
            m’ont oubliée, et je ferai de grandes choses pour tous mes enfants,
            quand ils me loueront et qu’ils loueront Dieu à travers moi. Je vous
            bénirai. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17 septembre 1990</h6>
          <p>
            Mes enfants, Priez le Père parce qu’Il vous écoutera. Jésus est
            venu, il a prié avec vous; apprenez de Lui qui est tout Amour du
            Père. <br />
            Dans la prière se trouvent le Chemin, la Vérité, la Paix; Il vous
            éclairera pour que vous parveniez à Lui. Que ceux qui prient le Père
            avec dévotion ne craignent pas parce qu’ils le rencontreront à
            travers mon Fils Divin. Ceux qui prient et qui ne pèchent pas,
            boiront à sa source. <br />
            Je vous bénirai. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Le 20 septembre 1990</h6>
          <p>
            Mes enfants, «Le monde adore le dieu baal, c’est le matérialisme.
            Dieu veut répandre sa<strong>Miséricorde</strong>sur cette terre et
            dans le monde et vous demande donc de chercher
            <strong>«SA MISÉRICORDE».</strong> Les jeunes adorent baal, ils
            tomberont donc peu à peu dans l’abîme insondable du mal.
            Convertissez-vous tous à Dieu». <br />
            Tu dois faire connaître ce message, la MISÉRICORDE est en train de
            donner une grande opportunité au monde; ce sera peut-être bientôt
            trop tard. «N’aie pas peur Maria». <br />
            Je vous bénirai. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Le 26 septembre 1990 (en prière)</h6>
          <p>
            Maria, Je te révélerai ce que je souhaite au moment où il sera
            nécessaire. Entre-temps, Dieu demande la prière et la pénitence pour
            le pardon des péchés; sans prière il n’y a pas de repentir. <br />
            Le monde est au bord du génocide, mon âme est triste, la clameur de
            voix monte jusqu’au Ciel. Pour les apaiser, pour que montent les
            prières, priez, priez ¡Mes pauvres enfants, mes pauvres enfants!{" "}
            <br />
            Je vous bénirai. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Octobre 1990</h6>
          <p>
            Maria, ma fille, <br />
            Une guerre très cruelle se déchaînera bientôt.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18 octobre 1990</h6>
          <p>
            Maria, ma fille, <br />
            Je veux que tu pries pour la Paix du monde, que tu fasses pénitence
            et que tu l’offres au Seigneur, ton Dieu. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>23 octobre 1990</h6>
          <p>
            (pendant que je disais mon Chapelet) <br />
            Aujourd’hui j’ai eu une vision de notre Sainte Mère, toute en blanc,
            de la tête aux pieds. D’abord elle a étendu ses bras et de ses mains
            sont sorties des lumières extraordinairement blanches et
            transparentes. Son aspect, si beau, était intensément triste et son
            visage tourné vers le bas. Ensuite elle a mis ses mains en attitude
            de prière et, en regardant vers le bas, elle est partie sans dire un
            mot.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 décembre 1990</h6>
          <p>
            (pendant que je priais, notre Sainte Mère a dit) <br />
            «JE SUIS MARIE, MÈRE DE TOUTES LES DOULEURS ET NOTRE DAME DES
            LARMES» <br />
            Elle m’a parlé de toutes les offenses que l’on fait au Seigneur en
            permanence et elle m’a montré le Divin CŒUR DE JÉSUS couronné
            d’épines.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9 septembre 1991</h6>
          <p>
            Ma fille, <br />
            La prière est le lien qui unit Dieu et les hommes. <br />
            Un matin, en me réveillant et en me disposant pour la prière, j’ai
            eu une vision de Jésus sur la croix, Il a dit: <br />
            «J’ai soif, donne-moi à boire»
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 11 mars 1992</h6>
          <p>
            Ma fille, Ecoute le message de ta Mère qui pleure pour tous ces
            enfants égarés. Je veux que tu pries sans cesse ¡Combien de péchés
            offensent le Seigneur! et dire qu’Il est mort et s’est livré pour
            vous tous, à la mort sur la Croix. Vous êtes indignes du Seigneur.{" "}
            <br />
            Priez tous pour que le monde se convertisse. <br />
            Priez, faites pénitence, regardez la Gloire de Jésus-christ, lisez
            l’Évangile, pratiquez la Parole de Dieu avec sincérité dans le cœur.{" "}
            <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4 juillet 1994</h6>
          <p>
            Le matin très tôt, alors que je faisais mes prières, j’ai vu devant
            moi un ANGE. En le voyant j’ai senti une grande joie, en moi et en
            dehors de moi. Un profond gémissement est alors sorti de ma bouche
            devant la présence de cet Ange d’extraordinaire beauté, ce n’était
            pas seulement sa beauté qui m’a impressionnée mais le fait que de sa
            présence émanait une grande joie qu’il me transmettait en me faisant
            éprouver un grand bonheur intérieur, très difficile à expliquer en
            mots. Il était habillé en blanc et portait un cordon autour de la
            taille, son aspect était robuste et resplendissant. Il m’a semblé
            qu’il avait 17 ans, ses cheveux étaient blonds et longs, juste
            jusqu’en dessous des oreilles. Il portait dans une main un long
            bâton dépassant sa tête et qui s’appuyait par terre. <br />
            Il s’est mis devant moi et pendant un long moment (je ne sais pas
            combien de temps) il n’a rien dit, il me regardait seulement avec
            fermeté et avec grande insistance. Je lui ai demandé: <br />
            Qui es-tu? <br />
            R: Je suis un Ange, j’appartiens à la garde royale des légions
            célestes, sous les ordres de l’Archange Saint Michel, pour la lutte
            contre Satan. <br />
            Ensuite il m’a dit: <br />
            Écoute attentivement, fais attention. Peut-être croient-ils que Le
            Seigneur Dieu permettra que l’on continue à commettre des
            abominations chez Lui? Dieu est un Père qui corrige. Son AMOUR
            atteint aussi bien les bons que les mauvais, sa patience est
            infinie, la colère de Dieu ne s’est pas encore déchaînée contre les
            personnes impitoyables, car Lui seul est le Créateur de tout ce qui
            existe, Lui seul est le pouvoir par dessus tout pouvoir, sa
            Miséricorde est infinie, l’Amour de Dieu est Sauveur. <br />
            Bienheureuse, toi qui agis bien, bienheureuses tes peines! (il est
            resté silencieux comme s’il attendait que je parle) Je lui ai
            demandé: <br />
            Que veux-tu que je fasse? <br />
            R: Je suis un serviteur. Lui, qui EST, m’envoie, sois un bon
            serviteur, fais comme moi. <br />
            Loué et Glorifié soit le Seigneur, pour toujours, Béni et Loué.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Le 13 mars 1995</h6>
          <p>
            (pendant que je priais les mystères Glorieux du Chapelet)
            Aujourd’hui j’ai eu une vision de la Sainte Vierge, NOTRE DAME DE
            SCHOENSTTAT, <br />
            <strong>Mère, Reine et Victorieuse</strong>. <br />
            La Vierge et l’Enfant Jésus ont pris vie sur la toile. Elle, la
            Sainte Vierge, était très souriante et l’Enfant aussi au milieu
            d’une grande luminosité radieuse. Le Divin Enfant Jésus dans ses
            bras caressait tendrement de sa petite main le visage de la Sainte
            Vierge, puis Il s’est penché, a embrassé le Cœur de Marie pour
            ensuite faire rentrer sa petite main dans la poitrine de la Vierge.
            Il a pris tendrement entre ses mains le Cœur de la Vierge, puis Il
            l’a tenu d’une main devant eux comme s’il l’offrait et, en même
            temps, il a béni avec l’autre main sur le Cœur Immaculé de la Vierge
            toute la ville et le monde. <br />
            Leurs visages étaient souriants et joyeux tout le temps, ils
            inspiraient une grande confiance. La vision est ensuite partie.
            <br />
            Après ceci, mon âme est restée extasiée avec une grande joie et une
            paix intérieure.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>20 mars 1995</h6>
          <p>
            Maria, ma fille, <br />
            Tu dois te confier, toujours, au Sacré Cœur Eucharistique de mon
            Fils Jésus, je veux que tu t’adresses à Lui constamment dans toutes
            tes prières. Je te demande aujourd’hui, fille de mon Cœur, de
            beaucoup prier pour les malades et d’essayer de faire en sorte que
            chaque âme et chaque cœur soit fortement attiré vers le Cœur du
            Christ qui souffre pour chacun d’entre vous, spécialement pour les
            malades, absorbe-toi dans la passion, pas à pas et prie pour les
            pécheurs, concentre-toi ma fille aux âmes vides et essaie de les
            remplir de ta prière pour que Jésus puisse pénétrer en elles. <br />
            C’est tout pour aujourd’hui, ma fille. Loué soit le Nom de mon Fils
            Jésus. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>22 mars 1995</h6>
          <p>
            Mes chers enfants, <br />
            Aujourd’hui je veux vous protéger du Malin, Satan œuvre, il essaiera
            de vous dominer, même à travers des personnes, même de celles qui
            sont dans l’Église. Satan et ses esprits malins ne se feront pas
            connaître facilement mais se couvriront d’une peau de brebis et
            subtilement sèmeront le mal. Il attaquera spécialement l’Église et
            tous les lieux où la Parole de mon Divin Fils Jésus est enseignée;
            il s’y installera pour essayer de vous perdre et beaucoup peuvent
            tomber dans son piège mortel, particulièrement ceux qui ne
            surveillent pas l’entrée de leur cœur. Je vous demande en permanence
            donc le jeûne, la prière, la pénitence, mortifiez votre corps pour
            vous rendre forts à l’intérieur. Je vous parle, à tous, restez
            vigilants parce que Satan vous surveille et attend toujours
            l’occasion de vous perdre. <br />
            Si je vous dis ceci, ce n’est pas pour vous faire peur mais pour
            vous prévenir, préparez-vous comme on prépare les champs pour les
            semailles, jour après jour, avec persévérance, louez Dieu dans
            chaque chose que vous faites, bénissez le Nom du Seigneur. <br />
            Que Dieu vous bénisse, mes enfants. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1 avril 1995</h6>
          <p>
            Aujourd’hui, pendant que je faisais le Chemin de Croix (dans ma
            chambre, j’ai eu la vision suivante) <br />
            J’ai vu, devant le Tabernacle de la paroisse, le Cœur blessé de
            Jésus. Le Cœur avait une profonde blessure et, comme il battait, une
            grande goutte de Sang sortait de la blessure et se répandait. Le
            Seigneur me faisait connaître, en même temps, la souffrance qu’il y
            avait dans ce spasme pendant que les gouttes de Sang sortaient; une
            douleur physique et morale. Cette douleur était tellement
            inexprimable que lorsque le Seigneur me l’a transmise, je n’ai pas
            pu la supporter et j’ai commencé à m’évanouir et j’ai senti que mon
            cœur ne résisterait pas, mais le Seigneur me l’a enlevée car
            autrement, je serais morte. <br />
            Le Seigneur m’a montré combien d’AMOUR il y a dans son Cœur Adoré.
            Combien d’AMOUR Il garde dans le Tabernacle VIVANT et PRÉSENT! AMOUR
            immense, infini pour nous, en souffrant à travers les siècles Sa
            Passion Salvatrice! <br />
            La Trinité Sainte est présente dans le<strong>Très</strong>
            <strong>Saint Sacré Cœur Eucharistique de Jésus</strong>. Après la
            fin de cette vision apparaissent les mots <br />
            «JE SUIS LE TRÈS SAINT SACRÉ CŒUR EUCHARISTIQUE DE JÉSUS, ADOREZ-MOI
            PERPÉTUELLEMENT EN RÉPARATION». Il m’a inspiré la prière suivante
            pour être dite au pied du Tabernacle. <br />
            <strong>
              <em>
                Très Saint Sacré Cœur Eucharistique de Jésus, J’ai une immense
                confiance en Ta Miséricorde, Je Te demande humblement de me
                donner la foi dont j’ai besoin pour m’abandonner à ta
                Miséricorde Infinie car mes ressources humaines se sont déjà
                épuisées et qu’il ne me reste qu’à me tourner avec confiance
                vers ta Compassion Infinie car je sais que tu écouteras ma
                supplique. Me voici Seigneur à tes pieds en demandant avec
                ferveur d’arranger toutes mes affaires et mes problèmes selon
                ton Amour et ton Approbation divine qui, je le sais, seront le
                mieux pour moi. Concède-moi ce que je te demande si c’est pour
                le bien de mon âme.
              </em>
            </strong>{" "}
            <br />
            <strong>
              <em> Prends Seigneur mon problème.</em>
            </strong>{" "}
            <br />
            <strong>
              <em>
                Prends mon cœur! J’ai confiance en Toi, Cœur Eucharistique de
                Jésus.
              </em>
            </strong>{" "}
            <br />
            <strong>
              <em> J’ai confiance en Toi, Cœur Eucharistique de Jésus.</em>
            </strong>{" "}
            <br />
            <strong>
              <em> J’ai confiance en Toi, Cœur Eucharistique de Jésus!</em>
            </strong>
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>21 avril 1995</h6>
          <p>
            (Dans le Sanctuaire de Notre Dame de Schönstatt) <br />
            Aujourd’hui, alors que j’adorais Jésus dans le Saint Sacrement, la
            Sainte Vierge a dit, <br />
            Mes chers enfants, <br />
            Je suis venue aujourd’hui pour vous demander de prier; priez pour
            toutes les personnes qui rencontrent des besoins, pour ceux qui sont
            persécutés, pour ceux qui souffrent de la faim et de l’abandon, pour
            les affligés et les malades, pour les enfants victimes du monde qui
            marchent sur une mer de méchanceté contaminée par le péché; si vous
            ne priez pas, mes chers enfants, l’humanité marche vers sa
            destruction. Vous êtes les élus pour arrêter, à travers vos prières,
            la punition qui les attend. <br />
            Priez le Père qui est au Ciel, faites-le au Nom de son Fils
            Jésus-christ. <br />
            Prière, prière, prière, écoutez cette Mère du Ciel qui sait comment
            racheter ses enfants. Soyez humbles, mes enfants, pour que votre
            prière parvienne au Ciel. <br />
            Béni et loué soit Dieu. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>10 mai 1995</h6>
          <p>
            Message de Jésus: <br />
            Lorsque viendra le jour du Jugement, tous ressusciteront, je vous
            l’assure, depuis le premier homme, Adam, et Ève, la première femme,
            et avec eux, le dernier des derniers et ce jour-là toute la création
            sera dans l’expectative; le ciel et la terre se verront l’un
            l’autre. <br />
            Le Père, Le Fils et L’Esprit Saint, la Gloire des Gloires, les bénis
            seront bénis et les maudits seront maudits. <br />
            Je vous ai envoyé Marie, ma Mère, celui qui l’écoute, m’écoute.
          </p>

          <div className="col-12 mt-5">
            <h6>11 mai 1995</h6>
            <p>
              Après avoir demandé à la Vierge par rapport à la «femme» Tu es une
              femme! Le désir le plus grand de mon Cœur c’est que quand on pense
              à Moi, on ne me sépare jamais de mon Fils Jésus. J’ai été conçue
              par Lui depuis le ventre de ma mère, je suis née pour Lui, ma vie
              pour Lui, avec Lui et en Lui, et maintenant que je suis avec Lui,
              c’est Lui tout mon Ciel. <br />
              Femmes du monde, le troisième millénaire approche, c’est la femme
              qui s’emparera de ces temps. Soyez fortes, que l’essence qui est
              venue en vous lorsque Dieu vous a offert la vie ne se perde pas.
            </p>
          </div>

          <div className="col-12 mt-5">
            <h6>13 juin 1995</h6>
            <p>
              Message de Jésus: <br />
              Le monde ne s’est jamais demandé combien de larmes J’ai versées
              pour vous pendant ma Passion et combien de larmes amères a versées
              ma Sainte Mère pour aider à la Rédemption. Je vous demande
              d’honorer chaque larme que J’ai versée pour vous pendant ces
              heures amères, Je promets à celui qui les honorera en disant tous
              les jours de sa vie cinq Pater, cinq Avemaria et cinq Gloria{" "}
              <br />1 - de l’assister, avec ma Sainte Mère, dans la bataille
              finale de sa vie, 2 - la conversion totale de son âme, 3 - une
              véritable contrition de ses péchés, 4 - le jour du jugement, de le
              pardonner pour qu’il entre avec Moi dans la Gloire.
            </p>
          </div>

          <div className="col-12 mt-5">
            <h6>9 août 1995</h6>
            <p>
              Mes enfants aimés, <br />
              Que la Paix et l’Amour du Seigneur soient avec vous tous. <br />
              Aujourd’hui je suis venue vous demander de prier le Saint Chapelet
              tous les jours, pour que votre conversion commence; le deuxième
              pas sera l’amendement de vos âmes à travers le Sacrement de la
              Confession et de la Sainte Messe. Vous qui pouvez le faire,
              participez-y tous les jours sans y manquer le Dimanche. Persévérez
              dans la prière quotidienne du Saint Chapelet, ce moyen si simple
              de prière transformera vos vies, soyez persévérants dans
              l’accomplissement de ces trois demandes et vous vous verrez
              bientôt transformés. Ce sera peut-être un effort au début mais si
              vous le faites je vous promets de grandes Grâces, accomplissez
              bientôt ma requête, la conversion est urgente, je veux avoir tous
              mes enfants, les portes du Ciel sont ouvertes à tous! <br />
              Ouvrez vos cœurs! Amen, amen.
            </p>
          </div>

          <div className="col-12 mt-5">
            <h6>15 août 1995</h6>
            <p>
              Maria, fille de mon Cœur, <br />
              Je veux que tu regardes le Ciel, là où j’habite en corps et âme
              Glorieux, en compagnie des Anges et des Saints; regarde-moi ma
              fille (elle m’a regardée et a ouvert ses mains, elle les a
              étendues et des éclairs de lumière très pure en sont sortis). Elle
              a dit: <br />
              Contemple mon bonheur, seulement, participes-y ma fille, c’est le
              cadeau de ta Mère du Ciel qu’elle veut partager avec toi. <br />
              Mon âme loue la grandeur du Seigneur et mon esprit a tressailli
              d’allégresse dans la Gloire de Dieu, éternelles sont les
              Miséricordes du Seigneur mon Dieu et Sauveur. Bienheureux ceux qui
              espèrent dans le Seigneur parce qu’ils seront rassasiés dans la
              source d’eau vive et plus jamais ils n’auront faim ou soif parce
              qu’ils verront Dieu. <br />
              Sois humble ma fille, prêche l’humilité, tu as tenu une grande
              bataille, n’aies pas peur. Je serai avec toi jusqu’à la fin, je
              suis l’Hostie Sainte dans ton cœur. <br />
              Amen. Alléluia. Amen. Alléluia.
            </p>
          </div>

          <div className="col-12 mt-5">
            <h6>5 septembre 1995</h6>
            <p>
              Mes enfants, <br />
              Ne vous rebellez pas contre votre Père qui est au Ciel mais au
              contraire, cherchez à lui rendre grâces et à le louer, à tout
              souffrir avec résignation et patience parce que c’est la vertu de
              la patience qui vous sanctifiera, offrez tout à Notre Seigneur, ne
              recherchez pas les choses vaines de ce monde mais au contraire
              priez. Dites le Saint Chapelet aussi souvent que possible, plus
              vous priez, plus vous recevez de grâces. <br />
              Si vous ne priez pas et ne vous confessez pas au moins une fois
              par mois vous ne grandirez pas spirituellement et vous donnerez de
              la place à l’adversaire pour vous retrouver affaiblis. <br />
              Convertissez-vous tous mes enfants! Fais connaître ceci. Amen.
              Alléluia. Amen. <br />
              Que Dieu vous bénisse.
            </p>

            <div className="col-12 mt-5">
              <h6>6 septembre 1995</h6>
              <p>
                Pourquoi mes messages restent-ils réservés? Ezéchiel chapitre
                15, chapitre 32.
              </p>
            </div>

            <div className="col-12 mt-5">
              <h6>25 septembre 1995</h6>
              <p>
                Mes enfants bien-aimés,
                <br />
                Je vous parle à tous, mes enfants, vous qui êtes réunis dans
                beaucoup d’endroits pour me vénérer. Je suis tellement
                contente!! parce que je vous vois, chacun, je vous écoute,
                chacun en particulier, je vois les mains qui s’étendent en me
                demandant des grâces. Je vous promets de porter toutes vos
                demandes au Ciel et de les déposer aux pieds de la Très Sainte
                Trinité, Je suis votre avocate, puissant intercesseur devant le
                Trône de Dieu. Je vous demande Prière et Réconciliation,
                J’intercéderai pour celui ou celle qui entendra ma demande pour
                que la vraie Paix du tendre CŒUR DE JÉSUS et la guérison de son
                âme lui soient données. <br />
                Je voudrais répéter ma demande en ce jour si spécial.
                CONSACREZ-VOUS TOUS AU CŒUR IMMACULÉ DE MARIE parce que mon Cœur
                Immaculée triomphera et vous, qui lui serez consacrés, vous
                triompherez avec Lui; consacrez-vous à mon Cœur à travers la
                prière quotidienne du Saint Chapelet! Oh, mes enfants, si vous
                saviez tout ce qui vous est donné lorsque vous dites avec
                dévotion le Saint Chapelet. <br />
                <em>
                  Réjouissez-vous dans l’espérance, vous qui vous tournez vers
                  Dieu!
                </em>{" "}
                <br />
                <em>
                  Béni et loué soit le TRÈS SAINT SACRÉ CŒUR EUCHARISTIQUE DE
                  JÉSUS
                </em>{" "}
                <br />
                <em>Béni et loué soit JÉSUS EUCHARISTIE</em> <br />
                <em>
                  Bénie et louée soit LA TRÈS SAINTE TRINITÉ présente dans la
                  SAINTE EUCHARISTIE.
                </em>
                <br />
                Amen Alléluia, Amen Alléluia.
              </p>
            </div>

            <div className="col-12 mt-5">
              <h6>13 octobre 1995</h6>
              <p>
                (en prière dans ma chambre) <br />
                Ma fille aimée, <br />
                Quelle satisfaction de recevoir toutes les louanges, les prières
                et les larmes d’amour pour mon Divin Fils Jésus, en particulier
                en ce jour. <br />
                Le monde doit se consacrer à mon Cœur Immaculé. Le temps s’est
                écourté, les signes vous préviendront que toutes les prophéties
                que je vous ai données au fil du temps se sont accomplies, plus
                intensément ces dernières années afin de vous inciter à une
                conversion urgente à Dieu. Mon cœur de Mère souffre parce que
                beaucoup de personnes font la sourde oreille à mes appels à la
                conversion urgente. <br />
                Le Seigneur me permet -par sa grande Miséricorde- de vous
                prévenir les choses terribles qui viendront pour l’humanité.
                Dans l’obscurité avoisinante la lumière ne brillera plus, les
                plus terribles des tribulations vous attendent, vous serez
                soumis à celles du physique qui seront totalement insupportables
                mais il y aura aussi celles de l’esprit qui seront aussi
                tortueuses que l’homme n’en a jamais souffert depuis sa
                création. <br />
                La haine de l’adversaire se déchaînera alors dans toute sa
                fureur et rendra folles les nations de la terre. Le feu tombera
                du ciel et tout le monde sera paralysé par la terreur; le fracas
                sera si grand qu’il ébranlera tout l’Univers, après il ne
                restera que les trois quarts de l’humanité. <br />
                Le signe que je vous ai annoncé sera visible pour les élus. Dieu
                le Père vous donnera le temps de vous abriter dans les endroits
                préparés pour cette grande occasion. Mes enfants, vous qui
                m’aurez entendue, vous serez préparés; mettez-vous à genoux ce
                jour-là et priez en pénitence: <br />
                <em>
                  Très Sainte Trinité, que votre Sainte Volonté soit faite, Ayez
                  Pitié de nous, Ayez Pitié, Ayez Miséricorde. Oh Dieu,
                  Miséricorde, Miséricorde!
                </em>
                <br />
                <em>Pour le Sang de l’Agneau ayez Pitié,</em>
                <br />
                <em>Pour la Passion de l’Agneau ayez Miséricorde</em>
                <br />
                <em>Pour les Plaies de l’Agneau ayez Pitié.</em>
                <br />
                <em>Pour Votre Fils l’Agneau de Dieu écoutez-nous</em>
                <br />
                <em>
                  Père, prends Pitié de nous pour le Nom Béni de ton Fils Jésus.
                  Amen.
                </em>
                <br />
                Je vous demande une conversion urgente au Cœur Immaculé de Marie
                afin de mitiger ces horreurs qui surviendront à cause des
                péchés, ma fille, le monde navigue sur un marécage immonde,
                submergé dans toutes sortes d’impuretés impossibles à comparer
                puisqu’on n’a jamais vu chose pareille depuis sa création.
                L’odeur nauséabonde remonte, dense, jusqu’à Dieu, peu nombreuses
                sont les âmes en prière, la punition est aux portes… <br />
                Mes suppliques arrêtent la Main de Dieu. Je demande plus de
                prière, particulièrement de ceux qui sont CONSACRÉS, priez sans
                cesse et surtout aimez Dieu qui est SAINT, SAINT, SAINT. <br />
                Que la Sainte Crainte de Dieu retourne dans les cœurs! <br />
                Ceux qui croient en mes mots et se convertissent, seront sauvés.
                Fais connaître ce message ma fille, aujourd’hui comme hier,
                c’est un APPEL URGENT À L’AMOUR DE DIEU. <br />
                Je te bénis fille de mon Cœur. <br />
                Amen. Amen. Amen.
              </p>
            </div>

            <div className="col-12 mt-5">
              <h6>29 octobre 1995(en prière)</h6>
              <p>
                Mes chers enfants, vous pensez que le Ciel est un endroit
                lointain et inatteignable. Certains n’y croient même pas, je
                veux vous dire aujourd’hui, mes chers enfants, que le Ciel est
                très près de vous. Je vous invite à entrer dans un Temple et à
                vous approcher du Tabernacle et à regarder vers Lui, vous
                contemplerez alors le Ciel ici sur la terre parce que c’est
                JÉSUS le Ciel et que le Ciel est là où Il est. Il est DIEU!
                Mettez-vous en prière en sachant qu’Il est présent dans tous les
                Tabernacles du monde. Laissez-vous guider par Lui, faites comme
                Il vous dira. <br />
                Je vous aime tous. Amen. Amen.
              </p>
            </div>

            <div className="col-12 mt-5">
              <h6>31 octobre 1995</h6>
              <p>
                Après avoir reçu la Communion, j’ai eu une vision quand j’ai
                fermé les yeux pour converser avec Jésus. Il a apparu comme avec
                son Visage du Saint Suaire, non pas comme dans une image ou sur
                une photo mais réel. Tout son Visage éclairé, toutes les
                souffrances visibles, cela a provoqué un effet profond dans mon
                âme. Les Yeux fermés, Il me regardait dans le cœur et moi, je le
                regardais avec mon cœur.
              </p>
            </div>

            <div className="col-12 mt-5"></div>
            <h6>5 novembre 1995</h6>
            <p>
              Mes enfants, <br />
              Je vous ramène un mot du Ciel ESPOIR! ESPOIR! ESPOIR! <br />
              Comment est-ce que mes enfants peuvent comprendre l’AMOUR DE DIEU
              s’ils vivent dans le désespoir? <br />
              Réfléchissez. <br />
              L’espérance c’est espérer en Dieu et seulement en Lui, tout
              espérer de Lui en y mettant tous vos efforts mais en regardant
              l’espérance qui est au Ciel. <br />
              Dans l’AMOUR que DIEU a pour vous tous se trouve l’espérance parce
              que DIEU est AMOUR et que l’AMOUR de DIEU contient tout. <br />
              Loué soit Jésus!
            </p>
          </div>

          <div className="col-12 mt-5">
            <h6>6 novembre 1995</h6>
            <p>
              Mes enfants bien-aimés, <br />
              Je suis venue vous rendre visite pour vous combler de bénédictions
              ramenées du Ciel même si beaucoup parmi vous ont du mal à y
              croire, parce qu’ils n’ont pas la foi. Mes enfants, si vous ouvrez
              vos cœurs, la Mère que je suis pourra vous amener à la conversion,
              je vous apporte beaucoup d’Amour et d’Espérance. <br />
              Je veux que tous écoutent mes messages. Moi, la Mère de Jésus, je
              suis très heureuse parmi vous parce que vous avez commencé à
              correspondre et bientôt vous verrez que le Seigneur sera parmi vos
              cœurs, spécialement les plus jeunes, car c’est sur eux que j’ai
              mis mon espoir. <br />
              Je vous invite à un changement radical dans vos vies, suivez avec
              attention mes messages car à travers eux je vous apprendrai à vous
              approcher de Dieu. Merci d’avoir ouvert vos cœurs! <br />
              C’est un temps de miséricorde! <br />
              Il y a une lumière qui brille parmi vous. Priez. Priez. <br />
              Béni et loué soit le Très Saint Sacré Cœur Eucharistique de Jésus.
            </p>
          </div>

          <div className="col-12 mt-5">
            <h6>18 novembre 1995</h6>
            <p>
              Prenez conscience, mes enfants chéris, que Dieu est vivant, tout
              près de vous. C’est Lui le créateur de tout ce que vos yeux
              regardent et même au-delà. <br />
              Je veux que vous commenciez à y penser sérieusement. Lisez la
              Sainte Bible, demandez à l’Esprit Saint de vous illuminer pour une
              plus grande compréhension. <br />
              Amen, amen.
            </p>
          </div>

          <div className="col-12 mt-5">
            <h6>18 novembre 1995</h6>
            <p>
              Hier soir j’ai eu une vision: <br />
              J’ai vu un jardin rempli de boutons de roses blanches les unes
              contre les autres. En demandant la signification de ce que je
              voyais, il m’a été manifesté: les roses blanches symbolisent la
              pureté.
            </p>
          </div>

          <div className="col-12 mt-5"></div>
          <h6>22 novembre 1995</h6>
          <p>
            Travaillez, travaillez mes enfants, travaillez avec joie pour le
            Royaume de Dieu. Gloire à Dieu! <br />
            Amen. <br />
            (Dans un message privé)
            <strong>Prière pour demander la Sagesse»</strong>
            <br />
            <em>Mon Dieu et Mon Seigneur Miséricordieux!</em>
            <br />
            <em>
              Donne-moi la Sainte Sagesse qui provient de ta bonté infinie,
            </em>
            <br />
            <em>Ouvre les yeux de ma foi à la lumière éternelle</em>
            <br />
            <em>
              Pour que je puisse voir avec eux, parce que ta Sagesse Seigneur,
            </em>
            <br />
            <em>Es plus rayonnante que le soleil.</em>
            <br />
            <em>Guide mes pensées Seigneur avec ta Sagesse</em>
            <br />
            <em>
              Pour qu’elle soit la source de mes connaissances et de mes
              actions.
            </em>
            <br />
            <em>Amen.</em>
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25 novembre 1995</h6>
          <p>
            Aujourd’hui j’ai une vision de la Sainte Mère en attitude de prière
            profonde, son visage reste abaissé. Elle a ses mains jointes
            ensemble à la hauteur de son visage, elle reste en silence pendant
            quelques minutes et me dit après: <br />
            Mes chers enfants, <br />
            Je vous appelle tous à la conversion et pour que cela arrive vous
            devez beaucoup prier. Demandez à l’Esprit Saint, à travers la prière
            quotidienne, d’agir dans vos cœurs afin que vous viviez comme de
            véritables chrétiens. <br />
            La prière est tellement importante que vous ne pouvez pas
            l’imaginer. Elle peut ouvrir un immense canal de Grâces si vous êtes
            constants. Commencez à prier aujourd’hui pour que l’Amour de Dieu
            remplisse tous les espaces de vos cœurs. <br />
            Le Saint Esprit est le seul qui puisse vous convertir et vous amener
            à la Sainteté. C’est Lui qui communique toutes les Grâces qui
            proviennent du SAINT, TRÈS SAINT, de la TRÈS SAINTE TRINITÉ. Soyez
            bénis mes enfants. Amen Alléluia Amen Alléluia. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 27 novembre 1995</h6>
          <p>
            Je vais essayer d’expliquer avec des mots ce que Dieu m’a communiqué
            dans mon âme, sans paroles. <br />
            Après avoir communié avec le Corps et le Sang de Jésus, l’immense
            AMOUR DE DIEU m’a envahie. Cet immense AMOUR est arrivé à mon âme
            dans un silence profond. Il est resté en moi et sans un mot a
            manifesté à mon cœur que cet AMOUR infini de Dieu, et par
            l’intermédiaire de nous qui le recevons dans la Sainte Communion,
            communique avec toutes les âmes, même avec celles qui ne le
            reçoivent pas, pour les appeler et leur donner la vie avec son
            immense AMOUR présent dans la EUCHARISTIE SACRÈE. <br />
            Et l’AMOUR me dit de prier ainsi:
            <em>Oh amour infini qui ne cesses d’appeler!</em>
            <br />
            <em>Oh Passion infinie qui n’arrêtes pas de souffrir!</em>
            <br />
            <em>Tu appelles</em>
            <br />
            <em>Tu souffres</em>
            <br />
            <em>Et aimes toutes les âmes</em>
            <br />
            <em>Parce que les âmes sont les âmes de ton Âme.</em>
            <br />
            <em>Amen.</em>
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28 novembre 1995</h6>
          <p>
            Jésus dit: <br />
            Je ne refuserai rien à l’âme qui sollicite avec confiance le TRÈS
            SAINT SACRE CŒUR EUCHARISTIQUE DE JÉSUS! <br />
            Je vous appelle et vous attends.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28 novembre 1995</h6>
          <p>
            Mes enfants chéris, <br />
            Mon Cantique, faites qu’il soit le vôtre. Louez le Seigneur avec
            parce qu’à chaque fois que vous le ferez, les Anges et les Saints
            chanteront dans le Ciel. <br />
            Amen. Alléluia. Amen. Alléluia. <br />
            Mon âme exalte le Seigneur, <br />
            exulte mon esprit en Dieu, mon Sauveur ! <br />
            Il s'est penché sur son humble servante ; <br />
            désormais, tous les âges me diront bienheureuse. <br />
            Le Puissant fit pour moi des merveilles ; <br />
            Saint est son nom ! <br />
            Son amour s'étend d'âge en âge <br />
            sur ceux qui le craignent. <br />
            Déployant la force de son bras, il disperse les superbes. <br />
            Il renverse les puissants de leur trône, il élève les humbles.{" "}
            <br />
            Il comble de biens les affamés, <br />
            renvoie les riches les mains vides. <br />
            Il relève Israël son serviteur, il se souvient de son Amour, <br />
            de la promesse faite à nos pères, en faveur d'Abraham et de sa race,
            à jamais. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>30 novembre 1995</h6>
          <p>
            Après avoir reçu la Sainte Communion Jésus dit: <br />
            «Je suis le Bien Infini qui souffre pour les âmes. Emmenez des âmes
            vers mon Cœur»{" "}
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1 décembre 1995 (premier vendredi du mois)</h6>
          <p>
            Après avoir reçu la Sainte Communion Jésus dit: <br />
            Je suis «LE TRÈS SAINT SACRÉ CŒUR EUCHARISTIQUE DE JÉSUS» <br />
            Venez près de mon Cœur, n’ayez pas peur. Je suis l’AMOUR sans
            limites. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1 décembre 1995(je priais et la Mère a dit)</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Je vous parle à tous en ce temps de Miséricorde. Ne le laissez pas
            s’écouler sans que vous ne soyez plus proches de Dieu. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4 décembre 1995</h6>
          <p>
            Enfants bien-aimés, <br />
            L’Esprit Saint habite en vous parce que vous êtes les enfants de
            Dieu. Ne vivez pas suivant vos corps mais suivant l’Esprit Saint,
            pensez, vivez selon l’Esprit, en priant et en demandant sa force
            pour conserver la grâce. <br />
            Ayez courage mes enfants, restez en prière. Je vous accompagne
            toujours. Amen. Amen. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 décembre 1995</h6>
          <p>
            En ce jour si spécial, je suis venue, mes enfants, pour vous offrir
            mon grand Amour envers vous. Tout mon être a été préservé très pur
            par la Sainte Trinité. Dans mon sein très pur s’est incarné le Verbe
            Immaculé et Saint, la Lumière Infinie qui allume toute l’éternité.
            Dans ce merveilleux Plan d’Amour de Dieu pour le salut de toute
            l’humanité. <br />
            Méditez ceci mes enfants, mettez la lumière dans vos cœurs,
            commencez à briller comme des flambeaux. <br />
            Béni, Loué et Glorifié soit Dieu.
          </p>
        </div>

        <div className="col-12 mt-5">
          <strong>12 décembre 1995</strong>
          <p>
            Sois obéissante ma petite fille, accomplis la mission, tu es
            messagère, instrument de foi, obéis au Très Haut pour que villes et
            villages du monde puissent aller plus haut dans la connaissance de
            l’Amour de Dieu. <br />
            Les peuples le loueront. N’aies pas peur! C’est dans la simplicité
            de ton cœur que le Seigneur se révèle. <br />
            Que le TRÈS SAINT SACRE CŒUR EUCHARISTIQUE DE JÉSUS soit loué.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>12 décembre 1995</h6>
          <p>
            Enfants bien-aimés, <br />
            Je suis venue pour vous guider dans le chemin de la vraie Vie qu’est
            Jésus. <br />
            Cette Mère, la vôtre, que je suis, rendra le chemin plus facile pour
            vous. Ouvrez vos cœurs! Écoutez mes messages, je veux que nous
            commencions à marcher ensemble à travers le chemin qui mène vers le
            Ciel. Priez le Saint Chapelet! Louez ainsi la Gloire de Dieu. Gloire
            à Dieu. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 décembre 1995</h6>
          <p>
            (après la Sainte Communion) Jésus dit: <br />
            «Je suis l’Amant éternel des âmes». Regardez la Gloire de mon Cœur
            Divin allumé par le feu de l’Amour pour vous, exposé à tous les
            regards.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17 décembre 1995</h6>
          <p>
            Chers enfants, <br />
            Je vous apporte la lumière que vous avez déjà en vous et que vous ne
            pouvez pourtant pas voir à cause de vos péchés. Je vous aiderai pour
            que vous voyiez la lumière du Christ dans vos cœurs. <br />
            L’œuvre de MISÉRICORDE du Seigneur envers ce peuple traversera les
            frontières et se répandra partout dans le monde. <br />
            Mes petits enfants, convertissez-vous tous! Faites attention à mon
            enseignement, la Paix arrive, l’Amour arrive, réjouissez-vous pour
            cet appel unique et urgent à la rencontre de Dieu. <br />
            Loué soit le Seigneur!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19 décembre 1995</h6>
          <p>
            Enfants chéris, <br />
            Adorez mon Enfant Jésus comme Joseph et moi nous l’avons adoré.
            Commencez à l’adorer dans le cœur, permettez-lui de naître chez vous
            pour ce Noël. <br />
            Je vous parle d’une Grâce très spéciale pour vous mes chers enfants,
            ne la laissez pas passer sans conversion. Je vous aime tous.
            Alléluia, Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27 décembre 1995</h6>
          <p>
            Tournez-vous vers Jésus mes enfants chéris, commencez par le
            regarder depuis le moment de sa naissance. Regardez la pauvreté dans
            laquelle est né le Sauveur. <br />
            Commencez à vivre avec le Divin Enfant Sauveur en mourrant à
            vous-mêmes et en naissant aux choses <br />
            <strong>célestes</strong>. <br />
            Alléluia, alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27 décembre 1995</h6>

          <p>
            Mes chers enfants, <br />
            Je vous exhorte à vivre en tant que vrais chrétiens, ENFANTS DE
            DIEU, et vos œuvres seront ainsi bonnes et vraies méritoires du
            Royaume de Dieu. Alléluia. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28 décembre 1995</h6>
          <p>
            Priez mes petits enfants jour après jour, pour
            <strong>connaître</strong>le BIEN et<strong>rejeter</strong>
            le MAL. <br />
            Amen. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1 janvier 1996</h6>
          <p>
            Enfants aimés, <br />
            Je veux que vous commenciez cette année ensemble avec la Mère de
            Dieu. <br />
            Mettez vos souhaits dans<strong>mon Cœur</strong>pour que Moi, Mère
            de Jésus et votre Mère, je puisse aider à ce que l’Amour du PÈRE, du
            FILS et du SAINT ESPRIT se réalise en vous. L’Amour infini de Dieu
            veut vous aider à mûrir dans la FOI, l’ESPÉRANCE et la CHARITÉ à
            travers moi, pour que dans vos vies se réalisent les œuvres
            parfaites de l’AMOUR DE DIEU qui est le<strong>Sauveur</strong>.{" "}
            <br />
            Réjouissez-vous mes enfants, chantez des louanges à la Sainte
            Trinité. <br />
            Convertissez-vous! Amen. Alléluia. Amen. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2 janvier 1996</h6>
          <p>
            Mes enfants bien -aimés,
            <br />
            Priez le Saint chapelet en famille, pense que lorsque vous faites
            ceci, Je vous accompagne. Commencez maintenant, en cette nouvelle
            année. Je veux être dans tous les foyers pour vous aider dans toutes
            les difficultés. Je veux que tous me connaissent. <br />
            Cette<strong>Grâce</strong>
            <strong>merveilleuse</strong>vous est offerte par el Seigneur, ne
            soyez pas indifférents, je vous aime tous! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <strong>5 janvier 1996</strong>
          <p>
            Priez les uns pour les autres, mes enfants, rappelez-vous que Dieu
            veut du mieux pour vous. Soyez solidaires dans la prière avec vos
            frères et sœurs qui souffrent; après avoir prié pour vos besoins,
            priez pour les autres. <br />
            Vous ne vivez pas seules, par l’Amour infini de Dieu vous avez des
            frères et des sœurs et vous devez partager l’Amour et la Paix du
            Seigneur. <br />
            Bénissez Dieu et bénissez les frères et sœurs, ainsi vous serez
            agréables aux yeux de Dieu, vous recevrez de grands bénéfices
            spirituels et la Paix de Dieu viendra dans vos cœurs. <br />
            Vivez ceci tel que je vous l’apprends! <br />
            Amen. Alléluia. Amen. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7 janvier 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Restez unis dans la prière au Tout Puissant. Soyez affamés de son
            Amour et vous serez comblés de l’Amour infini qui le peut tout. Ne
            laissez pas passer ce moment de Grâce. La Miséricorde infinie vous
            exhorte à une conversion urgente. <br />
            Connaissez-vous les uns les autres comme des enfants de Dieu,
            écoutez sa Parole et laissez-la pénétrer dans vos cœurs, implorez
            cette
            <strong>Grâce</strong>à son Amour Divin. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 janvier 1996</h6>
          <p>
            María, petite fille de mon Cœur, <br />
            Prier à l’aide du Saint chapelet c’est rester près de mon Cœur, à
            chaque fois que tu le pries, mon regard reste sur toi, mon Cœur
            écoute et ma supplique devient plus insistante. <br />
            Je suis un pont d’union entre toi et la Très Sainte Trinité. Je te
            bénis. Amen. Amen.{" "}
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>11 janvier 1996</h6>
          <p>
            Priez! Mes enfants, priez d’un amour intense! Les ténèbres menacent
            déjà l’humanité. Prenez l’arme qu’est le Saint chapelet!
            Obéissez-moi mes enfants pour que la Lumière vainque les ténèbres.
            Amen. Amen. Amen. <br />
            La Sainte Vierge est toute en blanc et son visage est couvert de
            Larmes; elle me permet de regarder son visage avant de me parler.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>11 janvier 1996</h6>
          <p>
            Jésus dit: <br />
            De quel droit réprimandez-vous vos Prêtres? Ne vous ai-je pas appris
            à vous aimer les uns les autres? <br />
            Si vous êtes mon peuple et vous êtes corrompus, chacun parmi vous
            porte une charge de péché. Remettez d’abord vos dettes pour que je
            vous pardonne, soyez de véritables administrateurs à Moi pour
            entamer l’œuvre de réparation dans sa juste mesure, dans la Sainte
            Crainte. Gardez les portes de mon Royaume avec mon Amour infini.
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17 janvier 1996</h6>
          <p>
            J’ai vu un champs sec, plein d’épines et de broussailles et, au
            milieu, un très beau jardin plein de rosiers avec d’énormes roses
            roses, qui contrastaient avec le champs, et de gigantesques arbres
            aussi aux cimes énormes et pleins d’énormes roses roses. <br />
            La Mère me dit: <br />
            Beaucoup de difficultés vous attendent en ce moment. Le beau jardin
            est mon Cœur au milieu du monde, les roses représentent ceux qui
            prient le Saint chapelet, ils grandissent comme ces arbres
            gigantesques qui s’élèvent vers le Ciel et donnent beaucoup de
            fruits spirituels. <br />
            Celui qui me donne son cœur et prie le
            <strong>Chapelet</strong>ne doit rien craindre dans ce monde parce
            que cette Sainte prière les élève par dessus toute difficulté et les
            protège spécialement de tout péril en les rapprochant rapidement de
            Dieu. En grandissant spirituellement, ils évitent d’être contaminés
            de toute méchanceté. <br />
            Voilà la protection que Dieu donne à ceux qui prient le Saint
            Chapelet. Prêchez ceci. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18 janvier 1996</h6>
          <p>
            Jésus dit: <br />
            «Venez vers Moi, vous qui êtes accablés, Je vous soulagerai dans vos
            peines.» Venez vous réfugier dans mon Sacré Cœur Eucharistique. La
            Très Sainte Mère dit: <br />
            Lorsque Mon Fils Divin parle, le Ciel et la Terre se prosternent en
            adoration. Chaque Mot de Dieu a le poids de toute l’éternité.
            Obéissez-Lui et louez-Le à travers la prière. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19 janvier 1996</h6>
          <p>
            Sainte Marie dit: <br />
            Les jeunes, je vous dis d’ouvrir vos cœurs à la Mère du Ciel pour
            que je puisse vous apprendre quel est le vrai chemin du bonheur. Si
            vous me permettez d’entrer dans vos vies, je vous conduirai par le
            droit chemin, je vous montrerai la vraie moralité qui doit exister
            dans vos vies, je vous apprendrai à être purs dans le corps et dans
            l’âme afin que vous connaissiez la vraie joie qui naît du Cœur de
            Jésus, mon Fils Divin. <br />
            Placez Jésus au centre de vos vies. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25 janvier 1996</h6>
          <p>
            Merci de m’avoir écoutée! <br />
            Je vais vous demander de vivre dans la prière en louant
            continuellement le Père Céleste. Vous pourrez faire Sa Volonté si
            vous avez la force et la lumière que seul le Saint Esprit vous
            donnera à travers la prière. <br />
            Jeûnez au moins une fois par mois, pour commencer. Jeûner veut dire
            se priver de quelque chose pour l’amour de
            <strong>Jésus</strong>. Vous ne connaissez pas le pouvoir du jeûne
            et de la prière. <br />
            Commencez à jeûner et à prier, tous, le pouvoir des ténèbres sera
            donc battu! <br />
            Je vous aime tous. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 1 février 1996</h6>
          <p>
            Chers enfants, <br />
            Priez pour la Paix! pour la paix et l’amour qui doivent régner dans
            chaque foyer et dans chaque cœur, spécialement pour la paix dans les
            cœurs. <br />
            Convertissez-vous totalement au Seigneur! Cherchez toujours à faire
            Sa Volonté; que rien ne vous arrête, battez-vous pour y parvenir au
            milieu des épreuves. <br />
            Restez en prière pour savoir discerner la Volonté de Dieu dans vos
            vies et pour la réaliser. <br />
            Retrouvez la paix dans vos cœurs à travers la prière. Je vous aime
            tous. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2 février 1996</h6>
          <p>
            Vous êtes mes enfants bien-aimés et bénis par Dieu; prêtez attention
            à mes messages car le Seigneur vous y appelle à une véritable
            conversion. Amen. Amen. <br />
            Lisez le Psaume 14.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3 février 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Je suis votre Mère! Je vous invite à mettre tout votre espoir dans
            le Seigneur. <br />
            Louez Dieu constamment, à chaque acte de votre vie; grandissez
            spirituellement à travers la prière. Vous ne pouvez pas vivre avec
            oie si vous n’avez pas Dieu dans vos cœurs. Pour vivre une véritable
            vie chrétienne, commencez à regarder Jésus, compénétrez-vous des
            choses divines jusqu’à ce que vous remplissiez complètement vos
            pensées et vos cœurs de l’Amour de Dieu. <br />
            Intéressez-vous à connaître la Volonté du Père en priant avec
            insistance et en jeûnant. <br />
            Regarder le frère qui souffre. Tendez vos mains vers les nécessiteux
            et mettez dans vos cœurs le désir ardent de prier pour
            <strong>eux</strong>. Vous obtiendrez ainsi des choses merveilleuses
            de l’Amour de Dieu. <br />
            Fortifiez-vous dans la prière! La paix augmentera ainsi dans vos
            âmes. <br />
            Soyez bénis! Gloire au Très Haut!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7 février 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Soyez de véritables imitateurs du Christ conformément aux
            enseignements qu’Il vous laissés. <br />
            Ouvrez le saint Évangile! Commencez à célébrer la Gloire de Dieu.
            Apprenez sa Parole Divine et ce qu’Il vous ordonne. La Parole de
            Dieu n’est pas à vivre suivant le monde mais pour nous préparer à
            vivre au Ciel. <br />
            Réjouissez-vous mes enfants! Le Seigneur est Miséricordieux avec
            ceux qui sont humbles dans le cœur, ne négligez pas ce moment si
            spécial. Amen. Alléluia. Amen. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 février 1996</h6>
          <p>
            Mes chers enfants, <br />
            Soyez forts en ce moment que vous devez vivre, glorifiez Dieu avec
            vos vies. Qu’à chaque moment de la journée le Seigneur soit loué à
            travers l’accomplissement de vos obligations et en donnant chacun de
            son mieux. <br />
            Agissez toujours avec le Saint Esprit de Dieu pour être vainqueurs,
            votre Père du Ciel vous appellera donc, chacun par son nom, et vous
            reconnaîtra comme Ses enfants. <br />
            Priez, mes enfants, priez. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>(Les Roses) 11 février 1996</h6>
          <p>
            Priez, mes enfants! et croyez en l’Évangile. <br />
            Convertissez-vous tous au Seigneur! Tous les peuples du monde
            retrouveront ainsi la paix. <br />
            Priez intensément pour que beaucoup d’âmes se tournent vers le
            Seigneur. Priez pour les malades parce que nombreux sont ceux qui
            souffrent sans connaître l’Amour de Dieu. Priez pour eux, mes
            enfants, priez. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>12 février 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Tournez vos yeux vers l’Eucharistie Sacrée, source de vie féconde et
            de santé éternelle. Rencontrez votre Dieu présent dans tous les
            Tabernacles du Monde. Priez intensément devant Jésus Eucharistie.
            Mettez-vous entre Ses Mains avec sincérité pour que
            <strong>Jésus, qui est tout Amour</strong>, puisse vous transformer.
            Restez humbles et respectueux en sa présence, Il est Dieu! Prêchez
            ceci. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 février 1996</h6>
          <p>
            Venez, mes enfants, vers mon Cœur Immaculé. Ce Cœur maternel sera
            votre force. Je vous protégerai toujours. «Je vous offre mon Cœur
            Immaculé plein d’Amour pour vous». <br />
            Amen. Alléluia. Amen. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>14 février 1996</h6>
          <p>
            Mes enfants, <br />
            Je suis triste parce que beaucoup parmi vous souffrent les
            conséquences de ce temps que vous vivez, la majorité essaie de
            résoudre les problèmes loin de Dieu; pour beaucoup Dieu n’existe
            pas. <br />
            Voici un temps de Miséricorde, je vous invite à vivre plus
            profondément dans<strong>l’Amour</strong>. Ouvrez vos cœurs à
            l’Amour qu’est
            <strong>Jésus-christ</strong>et Il vous écoutera; les ténèbres
            s’éloigneront de vous, vos âmes s’ouvriront pour recevoir l’Esprit
            de Dieu et la Sagesse Divine, qui sera votre conseillère. Si vous
            voulez être libres, réconciliez-vous bientôt avec Dieu. <br />
            Je vous aime tous. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>16 février 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Je veux que vous compreniez combien l’Amour du Père du Ciel est
            grand. Certains parmi vous vivent dans l’obscurité totale mais, par
            la Miséricorde Divine, ils reçoivent l’Amour de Dieu comme ceux qui
            vivent à la lumière du Saint Esprit. <br />
            Mes enfants, je suis venue vous apporter l’ESPOIR afin que ceux qui
            marchent dans les ténèbres soient éclairés. <br />
            Ne vivez pas les mésaventures de ce monde comme si c’étaient la fin
            ultime. Regardez tout à la lumière de la foi en la Parole que vous a
            laissée Jésus; Lui qui a tout souffert pour que vous restiez fermes
            dans le chemin qui mène vers le Ciel. <br />
            Convertissez-vous tous! Vous serez ainsi des éclaireurs du monde
            parce que vous reflèterez avec vos vies le
            <strong>Cœur Divin de mon Fils Jésus</strong>.
            <br />
            Gloire à Dieu! Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>17 février 1996</h6>
          <p>
            Priez le Seigneur avec le<strong>Saint Chapelet</strong>et invoquez
            la protection de Dieu à travers cette prière qui est puissante. Vous
            ressentirez bientôt dans vos vies la force et la lumière de l’Esprit
            Saint. <br />
            <strong>Le Saint Chapelet</strong>est l’ornement le plus beau de
            l’âme, recourrez-y à tout moment. <br />
            Je suis dans le Saint Chapelet en tant que Fille de Dieu, Mère de
            Dieu, Épouse de Dieu et Mère tendre de vous tous. <br />
            Je vous aime, mes enfantsª! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 19 février 1996</h6>
          <p>
            Dans la prière, mes enfants, vous rester unis au Père, au Fils et à
            l’Esprit Saint. <br />
            Lorsque, à travers la prière, vous laissez la porte de votre cœur
            ouverte à l’Amour infini de Dieu, vous recevez des Grâces
            extraordinaires. <br />
            Amen. Alléluia. Amen. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>23 février 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Rapprochez-vous de l’Amour infini du «Cœur Eucharistique de Jésus».{" "}
            <br />
            Voici des temps de préparation. Ne perdez pas de temps dans les
            choses vaines de ce monde, détachez-vous vite de tout esprit du mal.{" "}
            <br />
            Ecoutez mes messages avec un esprit de réflexion; je vous parle, mes
            chers enfants, pour que vous grandissiez spirituellement. Soyez bons
            et miséricordieux, confiez-vous à a Bonté Infinie du Seigneur afin
            que –à travers sa Grâce- vous soyez persévérants et que vous
            agissiez toujours en tant que bons chrétiens. <br />
            Tournez vos yeux vers Jésus. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 2 mars 1996</h6>
          <p>
            La Mère dit: <br />
            «Je suis la Gloire de ce peuple».
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3 mars 1996</h6>
          <p>
            Mes enfants, <br />
            Que l’Amour du Père, le Sacrifice du Fils et l’Espérance du Saint
            Esprit se manifestent en vous. <br />
            Offrez-vous à la Très Sainte Trinité avec vos actions et en priant.
            Profitez des biens de ce monde comme on profite de quelque chose
            d’éphémère et de passager. Bénissez et remerciez la générosité
            infinie du Seigneur qui vous les envoie. <br />
            En ce temps de préparation méditez la Parole du Seigneur avec une
            profonde humilité pour être acceptés au Ciel par votre Père, Dieu,
            qui connaît vos cœurs. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4 mars 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            C’est par l’Amour de Dieu que vous êtes dans le monde. <br />
            Suivez le Seigneur et convertissez-vous dans ce temps de grande
            Miséricorde pour vous. <br />
            Ouvrez les yeux àla Lumièredu monde qu’est el Rédempteur parce que
            le temps viendra où vous serez appelés au jugement et, après cela,
            des abîmes écarteront le bien et le mal. <br />
            Mes enfants, le Ciel vous attend tous. Venez à mon Cœur Immaculé et
            je vous conduirai à Dieu. <br />
            Je vous aime intensément. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5 mars 1996</h6>
          <p>
            Que la paix et l’Amour du Seigneur soient avec vous mes enfants
            bien-aimés. <br />
            Aujourd’hui, je suis venue vous dire de rester unis et en prière.
            Faites ceci pour combattre l’ennemi malin qui essaie, par tous les
            moyens, de vous priver de la paix, particulièrement la paix dans les
            foyers, en vous enfonçant dans l’abattement et l’angoisse et en vous
            éloignant ainsi de l’Amour de Dieu. <br />
            Priez dans les rues avec le Saint Chapelet en réparation pour le
            Cœur Immaculé de Marie. <br />
            Le Chapelet est votre planche de salut. <br />
            Priez avec force les uns pour les autres, vos cœurs brûlant dans la
            charité pour le frère qui souffre. <br />
            Placez tout votre espoir dans le<strong>Seigneur</strong>. Amen.
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6 mars 1996</h6>
          <p>
            Mes chers enfants, <br />
            Restez attentifs à l’Amour de Dieu. Aujourd’hui, je suis venue vous
            dire ce que le Seigneur veut de son peuple. Soyez des enfants
            fidèles qui savent comment être de véritables chrétiens. <br />
            Bénissez le Père qui est patient avec vous avec un Générosité
            Infinie. Ecoutez la Parole du Seigneur qui est Parole de Vie
            Eternelle et agissez en conformité pour ne pas trébucher. <br />
            Ceux qui quittent le droit chemin du Seigneur traînent de longues
            chaînes et la lumière ne brille pas dans leurs cœurs. Grandissez,
            mes enfants, dans sa Sainte Sagesse et vous vous unirez à votre
            Dieu. Prêchez ceci. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>6 mars 1996</h6>
          <p>
            «Consacrez-vous au Très Saint Sacré Cœur Eucharistique de Jésus».
            C’est un appel urgent de l’Amour de Dieu. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7 mars 1996</h6>
          <p>
            Que le mandat du Seigneur «Soyez Saints» s’accomplisse en vous.{" "}
            <br />
            Priez, mes enfants, pour cette intention.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 mars 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Levez vos yeux vers le Ciel et demandez au Seigneur de vous donner,
            dans la Divine MISÉRICORDE, des cœurs repentis. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 8 mars 1996</h6>
          <p>
            Ne défaillissez pas! Que les genoux ne se plient pas devant l’esprit
            du mal. Le Seigneur vous demande la conversion. Jeûnez et faites
            pénitence. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> 9 mars 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Soyez responsables, chacun de sa conscience chrétienne, pour vivre
            en plénitude la vraie liberté que vous a donnée le Seigneur. <br />
            Vivez l’Évangile selon l’Amour. Entraidez-vous, dans l’Amour, les
            uns les autres, ainsi chacun recevra le nécessaire pour ne pas se
            perdre. Priez mes enfants pour cette intention. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 mars 1996</h6>
          <p>
            Vous êtes tous appelés à la rencontre amoureuse avec votre Père,
            Dieu. Prêchez ceci. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>14 mars 1996</h6>
          <p>
            Mes enfants, <br />
            Je vous exhorte à regarder les merveilles de la création du Père.{" "}
            <br />
            Bénissez et adorez son Nom Saint qui a tout créé dans son Immense
            AMOUR. Repentissez-vous! <br />
            Retournez au troupeau du Seigneur et vous vivrez. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>15 mars 1996</h6>
          <p>
            Adorez le Saint Sacrement; adorez-Le avec le cœur, avec l’âme et
            avec tout votre être. Puis, demandez avec confiance et vous
            recevrez, mes enfants bien-aimés, tout ce qui vous manque pour
            devenir des enfants dignes de Dieu. Vivez vos vies avec Celui qui
            est l’Amour Infini, présent parmi vous dans l’Eucharistie Sacré.{" "}
            <br />
            Approchez-vous de sa Table et mangez-en tous. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>18 mars 1996</h6>
          <p>
            Mes enfants bien-aimés, <br />
            Ne cherchez pas de consolation matérielle, cherchez la consolation
            dans la prière. <br />
            Priez avec foi au milieu des difficultés pour Petre fidèles au
            Seigneur. <br />
            Vivez avec l’espérance dans vos cœurs. Abritez-vous dans mon
            <strong>Cœur Immaculé</strong>et vous triompherez. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19 mars 1996</h6>
          <p>
            Loué soit le Très Haut! <br />
            Mes enfants, je vous demande, en ce temps de conversion, de
            réfléchir sur vos vies, à la lumière de l’Evangile qui est Parole de
            Vie et de Sainte Sagesse. <br />
            Regardez vos consciences et réconciliez-vous avec Dieu. <br />
            Levez l’esprit vers Le Seigneur avec véritable constriction dans le
            cœur. <br />
            Ouvrez vos cœurs au Très Saint Sacré Cœur Eucharistique de Jésus!{" "}
            <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>21 mars 1996</h6>
          <p>
            Aujourd’hui j’ai eu une vision de Jésus en prière. Il fait nuit et
            il y a beaucoup d’étoiles dans le ciel. <br />
            Une voix me dit alors. «¡Il connaît ses brebis! Je comprends ceci
            dans mon cœur. <br />
            Le Seigneur nous connaît tous dans le temps et les circonstances de
            nos vies. Le Bon Berger est notre espoir. IL nous cherche, nous
            connaît et nous regarde depuis l’Éternité, Il «nous appelle». celui
            qui l’écoute s’approche à l’esprit d’Amour et Il reste avec nous
            dans son AMOUR. <br />
            <strong>
              <em>PRIÈRE</em>
            </strong>
            <br />
            <em>
              Ame Salvatrice de Jésus-christ, consomme mon âme jusqu’à la
              dernière goutte de désir de moi-même et rassasie-la du désir
              fervent de Ton Amour envers les âmes.
            </em>
            <br />
            <em>
              Que les gouttes de Ton Sang Rédempteur tombent dans mon cœur pour
              le transformer et l’entraîner vers ton Cœur Divin.
            </em>
            <br />
            <em>Amen.</em>
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26 mars 1996</h6>
          <p>
            Mes chers enfants, <br />
            Aujourd’hui, je suis venue vous rendre visite avec pour mission de
            vous rapprocher de Jésus, mon Fils Divin. Ecoutez mes paroles et
            pratiquez-les avec intégrité et conscience, mettez vos cœurs à ma
            disposition pour que je pénètre en eux avec la lumière de l’Esprit
            Divin et que vous puissiez ainsi connaître JÉSUS-CHRIST, votre
            Sauveur. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27 mars 1996</h6>
          <p>
            Si vous voulez un monde rempli d’amour «
            <strong>AIMEZ DIEUX PAR-DESSUS TOUTE CHOSE</strong>». <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>2 avril 1996</h6>
          <p>
            María, ma fille, <br />
            Tu dois supporter toutes le épreuves avec un grand amour pour Jésus
            Cricifié. La grâce de Dieu t’accompagnera. <br />
            Puissent les fruits abondants de ton cœur être donnés aux âmes les
            plus nécessiteuses quand tu pries. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>3 avril 1996</h6>
          <p>
            Lève ton cœur avec la Croix de mon FILS pour comprendre tout le
            mystère de son<strong>Amour</strong>. <br />
            Reste sur la Croix avec Jésus et ton cœur sera ainsi comblé de
            bénédictions. <br />
            Ceci est une promesse de Dieu. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4 avril 1996</h6>
          <p>
            JÉSUS dit: <br />
            Contemplez-moi et adorez-moi dans mon Très Saint Sacré Cœur
            eucharistique, vous êtes en MOI quand vous mangez Mon Corps et vous
            buvez Mons Sang et mon AMOUR infini est en vous. <br />
            Marie très Sainte dit: <br />
            Dans le miracle de la SAINTE EUCHARISTIE, vous pénétrez dans
            l’intensité de la LUMIÈRE TRINITAIRE.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5 avril 1996</h6>
          <p>
            Ma fille, <br />
            Se livrer au mystère de la Croix est se convertir. En embrassant la
            Croix pour l’amour de Jésus, l’amer devient doux, la douleur
            jouissance, le désespoir paix, la haine
            <strong>Amour</strong>. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>5 avril 1996</h6>
          <p>
            Au pied de la Croix et dans l’Agonie cruelle, la Gloire de Dieu
            recevait la Mère Douloureuse lorsque son Cœur s’ouvrait.{" "}
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>7 avril 1996 (Dimanche de Résurrection)</h6>
          <p>
            Gloire au Pouvoir de Dieu! Gloire au Saint Esprit! Réjouissez-vous
            dans la Résurrection du Seigneur! Gloire à Dieu! Gloire à Dieu!
            Gloire à Dieu!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 avril 1996</h6>
          <p>
            Mes enfants, <br />
            Convertissez-vous à Dieu continuellement! Soyez le reflet de Jésus,
            ainsi, ceux qui vous regarderont reconnaîtront en vous de véritables
            chrétiens. <br />
            Amen. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9 avril 1996</h6>
          <p>
            Nourrissez-vous constamment de la Parole de Dieu, cherchez toujours
            à faire sa volonté. <br />
            Tout le temps qui passe sans que vous ayez levé les yeux vers le
            Ciel est du temps perdu. Amen. Alléluia. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>10 avril 1996</h6>
          <p>
            Travaillez avec joie mes enfants dans les champs du Seigneur parce
            que le temps viendra où vous cueillerez ce que vous avez semé.{" "}
            <br />
            Soyez humbles et persévérants quand vous demandez cette
            <strong>Grâce</strong>au Seigneur. <br />
            Alléluia. Alléluia.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 avril 1996</h6>
          <p>
            (Aujourd’hui j’ai vue la Sainte Vierge profondément triste et
            affligée, toute vêtue en blanc et son visage parfait semblait
            couvert de sueur). Mes enfants, <br />
            Je suis venue vous demander de prier et prier encore de toute
            <strong>urgence</strong>pour la Paix du monde qui est sérieusement
            menacée par l’iniquité du terrible ennemi de Dieu. <br />
            Faites confiance à mon Cœur Immaculé qui vous guidera à travers des
            tribulations terribles. Je serai votre Conseillère, ne vous écartez
            pas de mon guidage, ne vous séparez pas du Saint chapelet et priez
            en permanence, Je suis votre Mère et je parle en tant que Mère.{" "}
            <br />
            Le message que je veux vous transmettre aujourd’hui est très dur et
            difficile à comprendre pour ceux qui vivent dans l’oubli que Dieu
            existe et même pour ceux qui, ayant conscience de Dieu, vivent
            insoucieux de sauver leur âme selon la chair et le monde. <br />
            Des choses terribles vous attendent, mes enfants, si vous ne tournez
            pas vos yeux vers Dieu car la terrible punition que Dieu enverra au
            monde est sur le point de commencer. Je vous en révèlerai une partie
            afin de vous mener vers la prière et le sacrifice et pour que vous
            ayez l’espoir de mitiger à travers vos prières ce châtiment si
            terrible. Voici un avis plein de l’AMOUR DE DIEU envers l’humanité.{" "}
            <br />
            Beaucoup d’âmes religieuses tomberont et s’écarteront du chemin du
            Seigneur pour vivre dans la tiédeur du monde, les prêtres qui
            resteront ne seront aucunement différents des civils: ils suivront
            le chemin du monde qui les conduira <br />
            vers l’apostasie, les religieuses suivront ce même chemin et
            beaucoup d’âmes de foi se perdront à cause d’eux.
          </p>
        </div>
      </LayoutMensajesVirgen>
    </>
  );
}
